import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { Subscription, of } from 'rxjs';
import { IntralinksFile } from '../../tamalelibs/models/intralinks.model';
import { IntralinksGroupConfig, IntralinksGroupActionType, IntralinksGroupReadyFeedback, IntralinksGroupLoadedFeedback } from './intralinks-group.model';
import { take, catchError } from 'rxjs/operators';
import { MiddleEllipsisText } from '../../widgets/middle-ellipsis/middle-ellipsis.model';

@Component({
    selector: 'tam-intralinks-group',
    templateUrl: './intralinks-group.component.html',
    styleUrls: ['./intralinks-group.component.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush
}

) export class IntralinksGroupComponent implements OnInit, OnDestroy, OnChanges {

    @Input() config: IntralinksGroupConfig;
    files: IntralinksFile[] = null;
    reloading = false;
    error = null;
    name: MiddleEllipsisText;
    noData = true;
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _changeDetectorRef: ChangeDetectorRef
    ) { }

    ngOnInit() {
        // load
        this._destroySubscriptions.push(this.config.actionSubject$.pipe(catchError(err => {
            this.error = err;
            this._detectChanges();
            return of(null);
        })
        ).subscribe((action) => {
            if (action.type === IntralinksGroupActionType.RELOAD) {
                // this.reloading = true;
                this.error = null;
                this._detectChanges();
                action.payload(this.config.id, this.config.workspaceId).pipe(take(1)).subscribe((files: IntralinksFile[]) => {
                    this.files = files;
                    this.noData = !this.files || this.files.length === 0;
                    // this.reloading = false;
                    this.config.feedbackSubject$.next(new IntralinksGroupLoadedFeedback());
                    this._detectChanges();
                });
            } else if (action.type === IntralinksGroupActionType.UPDATE) {
                const file = action.payload as IntralinksFile[];
                for (const data of file) {
                    if (data.parentId === this.config.id && data.workspaceId === this.config.workspaceId) {
                        this.files.map(item => item.id === data.id ? data : item);
                        this.files = this.files.map(item => {
                            let flag = false;
                            let index = -1;
                            for (let i = 0; i < file.length; i++) {
                                if (item.id === file[i].id) {
                                    flag = true;
                                    index = i;
                                    break;
                                }
                            }
                            if (flag) {
                                return file[index];
                            } else {
                                return item;
                            }
                        });
                    }

                }
                this._detectChanges();
            }
        }));
        this.config.feedbackSubject$.next(new IntralinksGroupReadyFeedback());
    }

    ngOnChanges(changes: SimpleChanges): void {
        // Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
        // Add '${implements OnChanges}' to the class.
        if (changes.config.currentValue.name && (!this.name || changes.config.currentValue.name !== this.name.full)) {
            let name = changes.config.currentValue.name.replace(/ /g, '\u00A0').replace(/>/g, '\u00A0>\u00A0');
            const chunks = name.split('>');
            // need to remove the first value from the chunks: not need to show the root title
            if (!this.config.showWorkspaceName) {
                chunks.shift();
            }
            name = chunks.join('>');
            if (chunks.length > 2) {
                const start = chunks[0] + '>';
                const end = '>' + chunks[chunks.length - 1];
                chunks.pop();
                chunks.shift();
                const middle = chunks.join('>');
                if (start.length + end.length > 40) {
                    this.name = new MiddleEllipsisText(name.slice(0, 20), name.slice(20, name.length - 20), name.slice(name.length - 20, name.length));
                } else {
                    this.name = new MiddleEllipsisText(start, middle, end);
                }
            } else {
                this.name = new MiddleEllipsisText(name, '', '');
            }
        }
    }
    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(subscription => {
            if (subscription && !subscription.closed) {
                subscription.unsubscribe();
            }
        });

    }

    private _detectChanges() {
        if (!this._changeDetectorRef['destroyed']) {
            this._changeDetectorRef.detectChanges();
        }
    }


}
